export default __webpack_public_path__ + "static/media/portfolio-hover-160.a4a22eb9.jpg";